import { render, staticRenderFns } from "./BatchDetailTabs.vue?vue&type=template&id=71009cfc&"
import script from "./BatchDetailTabs.vue?vue&type=script&lang=ts&"
export * from "./BatchDetailTabs.vue?vue&type=script&lang=ts&"
import style0 from "./BatchDetailTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports